module.exports = __webpack_public_path__ + "odstraneni-tetovaze_3_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/dermatologie/odstraneni-tetovaze_3_before_tn.jpg
// module id = 1426
// module chunks = 0